// Module
var code = "<p>[# connection-error] Ful noda websocket bağlantısı kuramadık.</p> <p>Olası sebepler: TODO</p> <ul> <li>sebep #1</li> <li>sebep #2</li> </ul> ";
// Exports
export default code;